import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { API_ENDPOINTS, CONSTS } from '../../utils/endpoints';
import { fetchCompanyDetails } from '../../../../redux/companySlice';
import { http_get } from '../../utils/api_client';
import LMGrid from '../../../organisms/grid/LMGrid';
import MaterialsTable from '../../../organisms/table/MaterialsTable';
import { DISPLAY_STYLES } from './IndexPage';
import Loader from '../../../organisms/loader/Loader';

const Walkthroughs = ({ displayStyle }) => {
  const dispatch = useDispatch();
  const [items, setItems] = React.useState([]);
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    dispatch(fetchCompanyDetails());
    setLoading(true);
    http_get(API_ENDPOINTS.GET_LEARNING_MATERIALS, { category: CONSTS.WALKTHROUGHS })
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => { })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (data.length > 0) {
      setItems(data);
    }
  }, [data]);

  const renderGrid = () => {
    return <LMGrid data={data} />;
  };

  const renderList = () => {
    return <MaterialsTable data={data} setUpdatedData={setData} />;
  };

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <div>
          {displayStyle === DISPLAY_STYLES.GRID ? renderGrid() : renderList()}
        </div>
      )}
    </div>
  );
};

export default Walkthroughs;
